class ProductTabs extends HTMLElement {
  constructor() {
    super();

    this.tab = this.querySelectorAll(".tab-title");
    this.tabContents = this.querySelector(".tabs-contents");
    this.tabContent = this.querySelectorAll(".tab-content");
    this.link = this.querySelectorAll(".toggleLink");
    this.readMore = this.querySelectorAll("[data-show-more-toogle]");
    this.tabClose = this.querySelectorAll(".pdViewTab-close");
    this.isVerticalPopup = this.dataset.vertical === "sidebar";
    this.isVerticalSidebarMobile =
      this.dataset.verticalMobile === "sidebar-mobile";

    for (let i = 0; i < this.tab.length; i++) {
      this.tab[i].addEventListener("click", this.tabActive.bind(this));
    }

    for (let i = 0; i < this.link.length; i++) {
      if (!this.link[i].classList.contains("is-always-open")) {
        this.link[i].addEventListener("click", this.tabToggle.bind(this));
      }
    }

    document.addEventListener("click", (e) => {
      if (
        e.target.matches("[data-show-more-toogle]") ||
        e.target.closest("[data-show-more-toogle]")
      ) {
        this.readMoreReadLess(e);
      } else if (
        e.target.matches(".pdViewTab-close") ||
        e.target.closest(".pdViewTab-close")
      ) {
        this.productTabClose(e);

        if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
          this.handleVerticalPopupClose(e);
        }
      }
    });

    if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
      document
        .querySelector(".background-overlay")
        ?.addEventListener("click", this.onBackgroundClick.bind(this));
    }

    this.ensureAlwaysOpenTabs();

    setTimeout(() => {
      if (window.innerWidth > 550) {
        const $thisContent = document.getElementById("tab-description-mobile");
        if (!$thisContent || $thisContent.classList.contains("is-always-open")) {
          return;
        }

        const tabHeight = $thisContent.offsetHeight;
        const maxHeight = parseInt(
          $thisContent.querySelector(".tab-showMore")?.dataset.desMax
        );

        if ($thisContent.querySelector(".tab-showMore") && tabHeight < maxHeight) {
          $thisContent.querySelector(".tab-showMore").remove();
        }
      }
    });
  }

  ensureAlwaysOpenTabs() {
    this.querySelectorAll(".tab-content--always-open").forEach((tabContent) => {
      const link = tabContent.querySelector(".toggleLink");
      const toggleContent = tabContent.querySelector(".toggle-content");

      tabContent.classList.add("is-active");
      link?.classList.add("is-open", "is-always-open");
      link?.setAttribute("aria-expanded", "true");

      if (toggleContent) {
        toggleContent.classList.add("is-show", "is-always-open");
        toggleContent.style.display = "block";
        toggleContent.style.maxHeight = "none";
      }
    });
  }

  closeAllToggleTabs(currentLink = null) {
    this.link.forEach((link) => {
      if (link.classList.contains("is-always-open")) return;

      if (link !== currentLink) {
        link.classList.remove("is-open");
        link.setAttribute("aria-expanded", "false");

        if (window.innerWidth <= 551 && link.classList.contains("show-mobile")) {
          link.classList.remove("show-mobile");
        }
      }
    });

    this.tabContent.forEach((tabContent) => {
      const toggleContent = tabContent.querySelector(".toggle-content");
      if (!toggleContent || toggleContent.classList.contains("is-always-open")) {
        return;
      }

      toggleContent.classList.remove("is-show");
      $(toggleContent).stop(true, true).slideUp("slow");
    });

    document.body.classList.remove("tab-popup-show");
    document.body.classList.remove("tab-popup-sidebar-show");
  }

  tabActive(event) {
    event.preventDefault();
    event.stopPropagation();

    const $this = event.currentTarget;
    const href = $this.getAttribute("href");
    if (!href) return;

    const id = href.replace("#", "");
    const buttonTab = document.querySelector(".an-horizontal-shaking");

    if (!$this.classList.contains("is-open")) {
      this.tab.forEach((element) => {
        element.classList.remove("is-open");
      });

      $this.classList.add("is-open");
      this.tabContents?.classList.add("is-show");
      buttonTab?.classList.add("open-tab-content");

      this.tabContent.forEach((element) => {
        if (
          element.getAttribute("id") === id ||
          element.classList.contains("tab-content--always-open")
        ) {
          element.classList.add("is-active");
        } else {
          element.classList.remove("is-active");
        }
      });
    }

    if ($this.classList.contains("open-tab-content")) {
      buttonTab?.classList.remove("open-tab-content");
    }

    this.ensureAlwaysOpenTabs();
    this.checkTabShowMore(id);
  }

  tabToggle(event) {
    event.preventDefault();
    event.stopPropagation();

    const $this = event.currentTarget;
    const $thisContent = $this.parentNode?.nextElementSibling;

    if (
      !$thisContent ||
      $this.classList.contains("is-always-open") ||
      $thisContent.classList.contains("is-always-open")
    ) {
      this.ensureAlwaysOpenTabs();
      return;
    }

    const isAlreadyOpen =
      $this.classList.contains("is-open") ||
      $thisContent.classList.contains("is-show") ||
      $thisContent.style.display === "block";

    if (isAlreadyOpen) {
      $this.classList.remove("is-open");
      $this.setAttribute("aria-expanded", "false");

      if (window.innerWidth <= 551 && $this.classList.contains("show-mobile")) {
        $this.classList.remove("show-mobile");
      }

      if (
        ($this.classList.contains("popup-mobile") && window.innerWidth <= 551) ||
        (this.isVerticalPopup && window.innerWidth > 550) ||
        ($this.classList.contains("sidebar-mobile") && window.innerWidth <= 550)
      ) {
        $thisContent.classList.remove("is-show");
        document.body.classList.remove("tab-popup-show");
        document.body.classList.remove("tab-popup-sidebar-show");
      } else {
        $($thisContent).stop(true, true).slideUp("slow");
      }

      return;
    }

    this.closeAllToggleTabs($this);

    $this.classList.add("is-open");
    $this.setAttribute("aria-expanded", "true");

    if (
      ($this.classList.contains("popup-mobile") && window.innerWidth <= 551) ||
      (this.isVerticalPopup && window.innerWidth > 550) ||
      ($this.classList.contains("sidebar-mobile") && window.innerWidth <= 550)
    ) {
      document.body.classList.add("tab-popup-sidebar-show");
      $thisContent.classList.add("is-show");
      document.body.classList.add("tab-popup-show");
    } else {
      $($thisContent).stop(true, true).slideDown("slow");
    }

    this.ensureAlwaysOpenTabs();
  }

  readMoreReadLess(event) {
    event.preventDefault();
    event.stopPropagation();

    const $this = event.target.closest("[data-show-more-toogle]");
    if (!$this) return;

    const id = $this.getAttribute("href")?.replace("#", "");
    const textShowMore = $this.getAttribute("data-show-more-text");
    const textShowLess = $this.getAttribute("data-show-less-text");
    const showMoreContainer = $this.closest(".tab-showMore");
    const desMax = showMoreContainer?.dataset.desMax;
    const target = id ? document.getElementById(id) : null;

    if (!showMoreContainer || !target) return;

    if ($this.classList.contains("is-less")) {
      showMoreContainer.classList.remove("is-less");
      $this.classList.remove("is-less");
      showMoreContainer.classList.add("is-show");
      $this.classList.add("is-show");
      $this.innerText = textShowMore;
      target.style.maxHeight = `${desMax}px`;
      this.tabContents?.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
    } else {
      showMoreContainer.classList.remove("is-show");
      $this.classList.remove("is-show");
      showMoreContainer.classList.add("is-less");
      $this.classList.add("is-less");
      $this.innerText = textShowLess;
      target.style.maxHeight = "unset";
    }
  }

  productTabClose(event) {
    event.preventDefault();
    event.stopPropagation();

    this.tabContents?.classList.remove("is-show");

    this.tab.forEach((element) => {
      element.classList.remove("is-open");
      document
        .querySelector(".an-horizontal-shaking")
        ?.classList.remove("open-tab-content");
    });

    this.tabContent.forEach((element) => {
      if (element.classList.contains("tab-content--always-open")) {
        element.classList.add("is-active");
        return;
      }

      element.classList.remove("is-active");
      document
        .querySelector(".an-horizontal-shaking")
        ?.classList.remove("open-tab-content");
    });

    if (window.innerWidth <= 551) {
      const $toggleContent = event.target.closest(".toggle-content");
      if (!$toggleContent?.classList.contains("is-always-open")) {
        $toggleContent?.classList.remove("is-show");
      }
    }

    this.ensureAlwaysOpenTabs();
  }

  checkTabShowMore(id) {
    if (window.innerWidth > 550) {
      const $thisContent = document.getElementById(id);
      if (!$thisContent || $thisContent.classList.contains("is-always-open")) {
        return;
      }

      const tabHeight = $thisContent.offsetHeight;
      const showMoreEl = $thisContent.querySelector(".tab-showMore");
      const maxHeight = parseInt(showMoreEl?.dataset.desMax);

      if (showMoreEl && tabHeight < maxHeight) {
        showMoreEl.remove();
      }
    }
  }

  onBackgroundClick(event) {
    if (event.target.closest(".toggle-content.is-show") != null) return;

    this.querySelector(".toggleLink.is-open:not(.is-always-open)")?.classList.remove(
      "is-open"
    );
    this.querySelector(
      ".toggle-content.is-show:not(.is-always-open)"
    )?.classList.remove("is-show");
    document.body.classList.remove("tab-popup-show");
    document.body.classList.remove("tab-popup-sidebar-show");

    this.ensureAlwaysOpenTabs();
  }

  handleVerticalPopupClose(event) {
    const icon = event.target;
    const toggleContent = icon.closest(".toggle-content");

    if (toggleContent?.classList.contains("is-always-open")) {
      this.ensureAlwaysOpenTabs();
      return;
    }

    toggleContent?.classList.remove("is-show");
    icon
      .closest(".tab-content")
      ?.querySelector(".toggleLink:not(.is-always-open)")
      ?.classList.remove("is-open");
    document.body.classList.remove("tab-popup-show");
    document.body.classList.remove("tab-popup-sidebar-show");

    this.ensureAlwaysOpenTabs();
  }
}

if (!customElements.get("product-tab")) {
  customElements.define("product-tab", ProductTabs);
}
